import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	dayStepper: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	dayStepperLabel: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.md,
		fontWeight: fontWeights.bold,
		minWidth: 272,
		textAlign: 'center',
		[THEME.queries.sm]: {
			minWidth: 0,
		},
	},
	demosControls: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[12],
		justifyContent: 'center',
	},
	emptyState: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		flexDirection: 'column',
		fontSize: fontSizes.sm,
		gap: SPACE[8],
		padding: `${SPACE[48]}px 0`,
		textAlign: 'center',
	},
	emptyStateDescription: {
		margin: 0,
	},
	emptyStateTitle: {
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	filterField: {
		width: 254,
		[THEME.queries.sm]: {
			width: '100%',
		},
	},
	filterFieldWide: {
		width: 284,
		[THEME.queries.sm]: {
			width: '100%',
		},
	},
	filterPanel: {
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[12],
		justifyContent: 'center',
		padding: SPACE[24],
		width: '100%',
		[THEME.queries.sm]: {
			padding: SPACE[16],
		},
	},
	officeSelect: {
		width: 200,
	},
	selectTrigger: {
		backgroundColor: THEME.colors.background.light,
		width: '100%',
	},
	tabContent: {
		paddingTop: SPACE[24],
	},
});
